import { call, put } from "redux-saga/effects";
import { courseAPI } from "@services/api";
import { deleteCourseActions } from "../slices";
import { showFailureToast, showSuccessToast } from "@helpers";

function* deleteCourseWorker({ payload }) {
  try {
    yield put(deleteCourseActions.pending());
    const response = yield call(courseAPI.deleteCourse, payload.id);
    yield put(deleteCourseActions.success(response));

    // if (payload.type === "course") {
    //   const responseGetAll = yield call(instructorCourseApi.getMyCourses);
    //   yield put(getMyCoursesActions.pending());
    //   yield put(getMyCoursesActions.success(responseGetAll));
    // } else if (payload.type === "upcoming") {
    //   const responseGetAll = yield call(instructorCourseApi.getMyCourses);
    //   yield put(getUpcomingCoursesActions.pending());
    //   yield put(getUpcomingCoursesActions.success(responseGetAll));
    // } else {
    //   const responseGetAll = yield call(instructorCourseApi.getMyCourses);
    //   yield put(getMyPurchasesActions.pending());
    //   yield put(getMyPurchasesActions.success(responseGetAll));
    // }
    // TODO: handle callback | onSuccess
    showSuccessToast("Delete course successfully");
  } catch (error) {
    showFailureToast("Delete course has failed");
    yield put(deleteCourseActions.failure(error));
    // TODO: handle callback | onFailure
  }
}
// importDynamicModules
export { deleteCourseWorker };
